import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  Renderer2,
  SecurityContext,
} from '@angular/core'
import { DomSanitizer, Title } from '@angular/platform-browser'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import moment from 'moment'
import { Router } from '@angular/router'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { BreadcrumbService } from '../../../../shared/components/breadcrumb/breadcrumb.service'
import { CommonService } from '../../../../shared/services/common.service'
import { PDPService } from '../../../pdp/services/pdp.services'
import { CalenderConfigService } from '../../../../shared/services/calender-config.service'
import { Discounts } from '../../../../models/discounts.model'

@Component({
  standalone: false,

  selector: 'vs-check-price-availability',
  templateUrl: './check-price-availability.component.html',
  styleUrls: ['./check-price-availability.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CheckPriceAvailabilityComponent implements OnInit {
  priceAvailabilityForm: FormGroup
  defaultDate = new Date()
  newDate
  isDateChanged = false
  payLoad: any
  breakUp = false
  productDetails
  showResults = false
  showCheckAvalabilityAction = false
  selectedLegalEntity
  showAvailabilityLoader = false
  view = 'pnaWidget'
  minDate = new Date()
  selectedCRDdate: any;
  fetchingPnA = false
  formSubmitted = false
  filterWeekend = this.calenderConfigService.isFilterWeekend()
  @ViewChild('viewBreakupLink')
  viewBreakupLink

  @ViewChild('breakupContent')
  breakupContent
  shippedFrmOptions: any[] = []
  otherInventoryLocations: any[] = []
  constructor(
    private breadCrumbService: BreadcrumbService,
    private title: Title,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private globalMessageService: GlobalMessageService,
    private renderer: Renderer2,
    public pdpService: PDPService,
    private translate: TranslationService,
    private calenderConfigService: CalenderConfigService,
    private domSanitizer: DomSanitizer
  ) {
    this.domSanitizer.sanitize(
      SecurityContext.NONE,
      this.renderer.listen(document, 'click', this.bodyClick.bind(this))
    )
  }

  ngOnInit(): void {
    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('landing.availPriceCheck')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    setTimeout(() => {
      this.title.setTitle('Check Price and Availability')
    }, 1000)

    this.priceAvailabilityForm = this.formBuilder.group({
      partNumber: ['', Validators.required],
      quantity: [1, [Validators.required, Validators.pattern('^[0-9]*$')]],
    })
  }

  dateChange(event) {
    this.isDateChanged = true
    var newData = event
      .toISOString()
      .slice(0, 19)
      .replace(/-/g, '/')
      .split('T')[0]
    let paramDate = newData.split('/')
    this.newDate = moment(event).format('YYYY/MM/DD')
    //this.priceAvailabilityForm.controls.customerRequestedDate.setValue(newDate);
  }

  checkPriceAndAvailability(selectedLegalEntity?) {
    this.formSubmitted = true
    this.otherInventoryLocations = []
    this.shippedFrmOptions = []
    if (this.priceAvailabilityForm.invalid) {
      return
    }

    let url
    let urlParam = []
    const partNumber = this.priceAvailabilityForm.get('partNumber').value
    const qty = this.priceAvailabilityForm.get('quantity').value
    this.pdpService.setProductId(partNumber)

    const todaysDate = moment(this.defaultDate).format('YYYY/MM/DD')
    if (this.isDateChanged === false) {
      this.payLoad = {
        quantity: qty,
        customerRequestedDate: todaysDate,
        /* selectedLegalEntity: {
          distributionChannel: 'GE',
          division: 'GE',
          isDefaultVsSalesArea: false,
          plant: '1811',
          salesOrganization: 'Jacksonville USA',
          uid: '1810'
        }, */
        selectedPlant: selectedLegalEntity || null,
      }

      this.selectedCRDdate = todaysDate;
    } else {
      this.payLoad = {
        quantity: qty,
        customerRequestedDate: this.newDate,
        /* selectedLegalEntity: {
          distributionChannel: 'GE',
          division: 'GE',
          isDefaultVsSalesArea: false,
          plant: '1811',
          salesOrganization: 'Jacksonville USA',
          uid: '1810'
        }, */
        selectedPlant: selectedLegalEntity || null,
      }

      this.selectedCRDdate = this.newDate;
    }

    urlParam = ['products', 'productCode']
    let lastPart = `checkPriceAndAvailability?`
    lastPart += `productCode=${encodeURIComponent(partNumber)}&checkPrice=true`
    urlParam.push(lastPart)
    // urlParam = ['products', partNumber, 'checkPriceAndAvailability'];
    url = this.commonService.constructUrl(urlParam)
    if (!selectedLegalEntity) {
      this.fetchingPnA = true
    }

    this.commonService.postData(url, this.payLoad).subscribe(
      (res: any) => {
        this.fetchingPnA = false
        if (res) {
          this.showResults = true
          this.showCheckAvalabilityAction = false
          this.productDetails = res
          this.productDetails.quantity = qty
          this.selectedLegalEntity = this.productDetails.plantAvailableAt[0]
          this.productDetails.plantAvailableAt.forEach((element) => {
            if (element.defaultPlant) {
              this.selectedLegalEntity = element
            }
            if (
              element.code == this.productDetails?.defaultSalesArea.uid ||
              element.code.slice(0, 3) ==
                this.productDetails?.defaultSalesArea.uid.slice(0, 3)
            ) {
              this.shippedFrmOptions.push(element)
            } else {
              this.otherInventoryLocations.push(element)
            }
          })
          this.productDetails.selectedLegalEntity = this.selectedLegalEntity
        }
        this.showAvailabilityLoader = false
      },
      (er) => {
        this.fetchingPnA = false
        this.showResults = false
        this.priceAvailabilityForm.controls['partNumber'].setValue('')
        this.formSubmitted = false

        if (er.error?.errors[0]?.type == 'UnknownIdentifierError') {
          this.globalMessageService.add(
            er.error.errors[0].message,
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        } else {
          this.globalMessageService.add(
            { key: 'landing.errorOccuredWhileFetchPrice' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
      }
    )
  }

  formateDate(date) {
    return moment(date).format('Do MMMM, YYYY')
  }

  onLegalEntitySelect(e) {
    this.showCheckAvalabilityAction = true
  }

  checkAvailability() {
    this.showAvailabilityLoader = true
    this.checkPriceAndAvailability(this.selectedLegalEntity)
  }

  redirectToReplacementProd(link) {
    this.router.navigate([link])
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    const qty = this.priceAvailabilityForm.get('quantity').value
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    if (qty > 9999) {
      this.priceAvailabilityForm.controls['quantity'].setValue('9999')
    }
    return true
  }

  onQtyBlur(event) {
    const qty = this.priceAvailabilityForm.get('quantity').value
    if (isNaN(qty)) {
      this.priceAvailabilityForm.controls['quantity'].setValue('1')
    } else if (qty > 9999) {
      this.priceAvailabilityForm.controls['quantity'].setValue('9999')
    } else if (qty < 1 || qty == '') {
      this.priceAvailabilityForm.controls['quantity'].setValue('1')
    }
  }

  get f() {
    return this.priceAvailabilityForm.controls
  }

  getDiscountName(code) {
    return Discounts[code]
  }

  getTotalDiscounts(basePrice, netPrice) {
    let totalDisc = ''
    if (basePrice && netPrice) {
      totalDisc =
        basePrice.formattedValue[0] +
        (basePrice.value - netPrice.value).toFixed(2)
    }
    return totalDisc
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.uid === c2.uid : c1 === c2
  }

  bodyClick() {
    if (
      this.viewBreakupLink &&
      !this.viewBreakupLink.nativeElement.contains(event.target) &&
      this.breakupContent &&
      !this.breakupContent.nativeElement.contains(event.target)
    ) {
      this.breakUp = false
    }
  }
}
